import { render, staticRenderFns } from "./search-high.vue?vue&type=template&id=452ff5fe&scoped=true&"
import script from "./search-high.vue?vue&type=script&lang=ts&"
export * from "./search-high.vue?vue&type=script&lang=ts&"
import style0 from "./search-high.vue?vue&type=style&index=0&id=452ff5fe&lang=scss&scoped=true&"
import style1 from "./search-high.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ff5fe",
  null
  
)

export default component.exports